module.exports = __webpack_public_path__ + "img/banner_left.140fbae4.png";